import { useState } from "react";
import { api } from "../api/client";

export default function LoginPage({ onLogin }: { onLogin: (token: string) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await api.login(username, password);
      onLogin(res.data.token);
    } catch {
      setError("Falsche Zugangsdaten");
    }
  };

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center">
      <div className="bg-dark-800 p-8 rounded-xl w-80 border border-dark-600">
        <h1 className="text-accent text-2xl font-bold mb-6 text-center">📈 Trading System</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            className="w-full bg-dark-700 border border-dark-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
          <input
            type="password"
            className="w-full bg-dark-700 border border-dark-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          {error && <p className="text-red text-sm">{error}</p>}
          <button type="submit"
            className="w-full bg-accent text-dark-900 font-medium rounded-lg py-2 text-sm hover:opacity-90 transition">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
